import React from "react"
import { withRouter } from "react-router-dom"

const NonAuthLayout = props => {
  return (
    <React.Fragment>
      <div className="gt-auth-wrapper">{props.children}</div>
    </React.Fragment>
  )
}

export default withRouter(NonAuthLayout)
